import _camelCase from 'lodash/camelCase';
import actionTypes from '../actions/actionTypes';

export const INITIAL_STATE = {
  loading: false,
  error: false,
  alterationsCount: {
    overdue: 0,
    completed: 0,
    inProgress: 0,
  },
  overdue: null,
  completed: null,
  inProgress: null,
  archive: null,
  foundAlterations: {
    count: null,
    items: [],
  },
  alterationItemDetails: {},
};

const updateAlterationsData = ({ dataType, count, items }, state) => {
  const storeKey = _camelCase(dataType);
  const currentItems = state[storeKey]?.items || [];
  return {
    [storeKey]: {
      count,
      items: [...currentItems, ...items],
    },
  };
};

export const alterationsReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.ALTERATIONS_COUNT_LOADING:
    case actionTypes.ALTERATIONS_ITEMS_LOADING:
    case actionTypes.ALTERATIONS_SEARCH_LOADING:
    case actionTypes.ALTERATIONS_ITEM_DETAILS_LOADING:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.ALTERATIONS_COUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        alterationsCount: payload,
      };
    case actionTypes.ALTERATIONS_COUNT_ERROR:
    case actionTypes.ALTERATIONS_ITEMS_ERROR:
    case actionTypes.ALTERATIONS_SEARCH_ERROR:
    case actionTypes.ALTERATIONS_ITEM_DETAILS_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case actionTypes.ALTERATIONS_ITEMS_SUCCESS:
      return {
        ...state,
        ...updateAlterationsData(payload, state),
        loading: false,
      };
    case actionTypes.ALTERATIONS_SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        foundAlterations: {
          count: payload.count,
          items: [...state.foundAlterations.items, ...payload.items],
        },
      };
    case actionTypes.ALTERATIONS_ITEM_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        alterationItemDetails: payload,
      };
    case actionTypes.ALTERATIONS_SEARCH_CLEAR:
      return {
        ...state,
        loading: false,
        foundAlterations: {
          ...INITIAL_STATE.foundAlterations,
        },
      };
    case actionTypes.ALTERATIONS_ITEMS_CLEAR:
      return {
        ...state,
        overdue: null,
        completed: null,
        inProgress: null,
        archive: null,
      };
    case actionTypes.ALTERATIONS_ITEM_DETAILS_CLEAR:
      return {
        ...state,
        alterationItemDetails: {},
      };
    default:
      return state;
  }
};

export default alterationsReducer;
